// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const vehicleApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addVehicle: builder.mutation({
      query: (data) => {
        return {
          url: "vehicles",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateVehicle: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `vehicles/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteVehicle: builder.mutation({
      query: (id) => {
        return {
          url: `vehicles/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllVehicle: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `vehicles?${queryString}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getVehicleReviews: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `reviews?${queryString}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 3000,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddVehicleMutation,
  useUpdateVehicleMutation,
  useDeleteVehicleMutation,
  useGetAllVehicleQuery,
  useGetVehicleReviewsQuery,
} = vehicleApi;
